import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { RestangularModule, Restangular } from "ngx-restangular";
import {API_URL } from '../config';

@Injectable()
export class AssessmentService {
  private apiUrl = "/api/v1";
  private apiUrlNew = API_URL+"/api/v1";   //"https://qhsebe.ilooopsqhse.com/api/v1";

  constructor(private http: HttpClient, private restangular: Restangular, ) {}

  // Add a new assessment with Authorization header
  addAssessment(assessmentData: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(`${this.apiUrlNew}/competancy-ass`, assessmentData, {
      headers,
    });
  }

  // Update an existing assessment by ID with Authorization header
  updateAssessment(id: number, assessmentData: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.put(
      `${this.apiUrl}/competancy-ass/${id}`,
      assessmentData,
      {
        headers,
      }
    );
  }

  // Delete an assessment by ID with Authorization header
  deleteAssessment(id: number): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.delete(`${this.apiUrl}/competancy-ass/${id}`, { headers });
  }

  // Get a list of all assessments with Authorization header
  // getAssessments(): Observable<any> {
  //   const headers = this.getAuthHeaders();
  //   return this.http.get(`${this.apiUrl}/competancy-ass`, {
  //     headers,
  //   });
  // }


  public getAssessments() {
    return this.restangular.one("getAssessments");
  }

  public updateAssType(id) {
    return this.restangular.one("updateAssType/" + id);
  }

  public getContractsProj(id) {
    return this.restangular.one("getContractsProj/" + id);
  }

  public addNewProj() {
    return this.restangular.all("addNewProj");
  }

  public getDesignations() {
    return this.restangular.one("addNewProj");
  }

  public getAllAssType() {
    return this.restangular.one("getAllAssType");
  }

  

  public retrieveDesignations() {
    return this.restangular.one('retrieveDesignations');
  }

  public retrieveProjects() {
    return this.restangular.one('retrieveProjects');
  }

  public retrieveAssHeaders() {
    return this.restangular.one('retrieveAssHeaders');
  }



  

  public deleteAssType(id) {
    return this.restangular.one("deleteAssType/" + id);
  }


  getAssessmentById(id: number): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(`${this.apiUrlNew}/competancy-ass/${id}`, {
      headers,
    });
  }

  private getAuthHeaders(): HttpHeaders {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("refresh_token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return headers;
  }



  
  public deleteProject(id) {
    return this.restangular.one("deleteProject/" + id);
  }

  public deleteDesig(id) {
    return this.restangular.one("deleteDesig/" + id);
  }

  
  public deleteMapAss(id) {
    return this.restangular.one("deleteMapAss/" + id);
  }






  public getwidgetDropdown() {
    return this.restangular.one("getwidgetDropdown");
  }


}



// WEBPACK FOOTER //
// /app/src/app/services/assessment.service.ts